// QRCodeScanner.js
import React, { useState, useEffect } from "react";
import QrScanner from "react-qr-scanner";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  // SwipeableDrawer,
  // List,
  // ListItem,
  // ListItemText,
  // Divider,
} from "@mui/material";
import "./QRCodeScanner.css";
import ReusableDialog from "../../components/ReusableDialog";
import ScanSuccessPage from "./ScanSuccessPage";
import { orderMeal } from "../../Apis/dashboardApis";
import { useDispatch, useSelector } from "react-redux";
import { setAlert } from "../../redux/alertSlice";
import { setPlateCount } from "../../redux/mealSlice";

const QRCodeScanner = ({ setScanData }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mealFor = useSelector((state) => state.meal.mealFor);
  const mealCount = useSelector((state) => state.meal.mealCount);
  const guestInfo = useSelector((state) => state.meal.guestInfo);
  const [result, setResult] = useState("No result");
  const [isScanning, setIsScanning] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const preventReload = (event) => {
      if (location.pathname === "/mobile/scan") {
        event.preventDefault();
        event.returnValue = ""; // Blocks the reload.
      }
    };

    // Add the beforeunload event listener
    window.addEventListener("beforeunload", preventReload);

    // Cleanup event listener when component unmounts
    return () => {
      window.removeEventListener("beforeunload", preventReload);
    };
  }, [location]);

  const handleError = (error) => {
    console.error("QR Scanner Error:", error);
  };

  const previewStyle = {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  };

  const handleScan = (data) => {
    if (!mealFor && !mealFor?.length) {
      return dispatch(
        setAlert({
          message: "Cancel and Click the Scan Button Again",
          severity: "error",
        })
      );
    }
    if (data) {
      let parsedResult;
      try {
        parsedResult =
          typeof data.text === "string" ? JSON.parse(data.text) : data.text;
      } catch (error) {
        parsedResult = { rawData: data.text };
      }
      console.log("result", parsedResult.data);

      // Define required fields
      const requiredFields = [
        "locationId",
        "locationName",
        "mealId",
        "mealType",
        "vendorId",
      ];
      const scannedData = parsedResult.data || {};

      // Check if all required fields are present
      const isDataValid = requiredFields.every((field) =>
        scannedData.hasOwnProperty(field)
      );

      if (!isDataValid) {
        dispatch(
          setAlert({
            message: "Invalid QR code. Missing required fields.",
            severity: "error",
          })
        );
        return; // Exit the function without opening the dialog
      }

      const finalResult = {
        ...scannedData,
        mealCount: mealCount,
        mealFor: mealFor,
        guestInfo: guestInfo,
      };

      setResult(finalResult);
      setIsOpen(true);
    }
  };

  const handleOrderMeal = async () => {
    setIsLoading(true);
    try {
      const response = await orderMeal(result); // Call the API
      if (response?.data?.status === true) {
        dispatch(
          setAlert({ message: response?.data?.message, severity: "success" })
        ); // Show success alert
        dispatch(setPlateCount(response?.data?.plateCount)); // Reset the plate count
        setIsScanning(false); // Stop scanning
        setIsOpen(false); // Close the dialog
        setShowSuccessPage(true); // Show the success page
      } else {
        dispatch(
          setAlert({
            message: response?.data?.message || "An error occurred",
            severity: "error",
          })
        ); // Show error alert
      }
    } catch (error) {
      dispatch(
        setAlert({
          message: error?.message || "An error occurred",
          severity: "error",
        })
      ); // Show error alert for API failure
    }
    setIsLoading(false);
  };

  const handleCancel = () => {
    setIsScanning(false);
    navigate("/mobile/dashboard");
  };

  const videoConstraints = {
    video: {
      facingMode: "environment", // Use the rear camera
    },
  };

  return (
    <>
      {showSuccessPage ? (
        <ScanSuccessPage
          cityName={result?.locationName}
          mealType={result?.mealType}
        />
      ) : (
        <>
          {/* QR Scanner */}
          {isScanning && (
            <div className="scanner-container">
              <div className="scanner-frame">
                <QrScanner
                  delay={300}
                  style={previewStyle}
                  onError={handleError}
                  onScan={handleScan}
                  constraints={videoConstraints}
                />
                <div className="scanner-line" />
              </div>
              <Box
                display="flex"
                justifyContent="center"
                mt={4}
                className="cancel-scan-btn"
              >
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  sx={{ background: "#004D72 !important", color: "white" }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Box>
            </div>
          )}

          <ReusableDialog
            open={isOpen}
            onClose={handleCancel}
            title="Scan"
            onConfirm={handleOrderMeal}
            cityName={result?.locationName}
            mealType={result?.mealType}
            isLoading={isLoading}
          />
        </>
      )}
    </>
  );
};

export default QRCodeScanner;
